<div class="wrapper">
  <div class="breadcrumb-container">
    <p-breadcrumb [model]="breadcrumbItems" styleClass="breadcrumb" />
  </div>
  <div class="emr-page-container">
    <div class="emr-page-title">Assign Patients</div>
    <div class="tables-container">
      <div class="table-container">
        <div class="table-container-header">
          <h2>Students</h2>
        </div>
        <p-table #studentTable [value]="inputStudents" class="emr-table" [loading]="isLoading" [filterDelay]="0"
          dataKey="id" selectionMode="multiple" [(selection)]="selectedStudents">
          <ng-template pTemplate="header">
            <tr>
              <th> <p-tableHeaderCheckbox /> </th>
              <th>
                <div>Student Name</div>
              </th>
              <th> Currently Assigned Patients: </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-inputStudent>
            <tr class="p-selecteable-row">
              <td>
                <p-tableCheckbox [value]="inputStudent" />
              </td>
              <td>
                {{ inputStudent.firstName}} {{ inputStudent.lastName }}
              </td>
              <td>
                {{ patientNamesForStudent(inputStudent) }}
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8" style="text-align: center; padding: 3rem">No students found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <p-divider layout="vertical"></p-divider>

      <div class="table-container">
        <div class="table-container-header">
          <h2>Select patients to assign </h2>
        </div>

        <p-table #patientTable [value]="patients" class="emr-table" [filterDelay]="0" selectionMode="multiple"
          [(selection)]="selectedPatients" selectionMode="multiple" dataKey="mrn">
          <ng-template pTemplate="header">
            <tr>
              <th> <p-tableHeaderCheckbox /> </th>
              <th>
                <div>Patient Name</div>
              </th>
              <th>
                Type
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-patient>
            <tr class="p-selectable-row">
              <td>
                <p-tableCheckbox [value]="patient" />
              </td>
              <td>{{ patient.getNameFirstMiddleLast() }}</td>
              <td>{{ patient.getType() }} </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8" style="text-align: center; padding: 3rem">No patients found.</td>
            </tr>
          </ng-template>
        </p-table>

      </div>
    </div>
  </div>
  <button class="assign-btn" pButton type="button" label="Assign Patients to Students" icon="pi pi-save"
    (click)="saveSelectedPatients()" [loading]="isSaving"
    [disabled]="selectedStudents.length === 0 || selectedPatients.length === 0">
  </button>
  <p-toast />
</div>